import { render } from "./PharmacyPaymentSuccess.vue?vue&type=template&id=fe751ace&scoped=true"
import script from "./PharmacyPaymentSuccess.vue?vue&type=script&lang=js"
export * from "./PharmacyPaymentSuccess.vue?vue&type=script&lang=js"

import "./PharmacyPaymentSuccess.vue?vue&type=style&index=0&id=fe751ace&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe751ace"]])

export default __exports__